<template>
  <div class="drawer-detail">
    <div v-if="hasCognize" class="field-type">
      <span class="label">阿尔法公司认知:</span>
      <div class="cognize-box">
        <span v-for="field in cognizeFields"  :key="field">{{translateTag[field]||field}}:{{company[field] }}</span>
      </div>
    </div>
    <div v-for="field in ['一句话简介', '公司介绍']" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <pre class="value company-pre">{{company[field]}}</pre>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['一句话简介', '公司介绍','人员受认可度', '固定薪酬', '激励机制', '人员稳定性'],
      translateTag: {
        一句话简介: '一句话介绍',
      },
    }
  },
  computed: {
    hasCognize() {
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      let flag = false
      for(const field of fields){
        if(this.company[field]) flag = true
      }
      return flag
    },
    cognizeFields(){
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      const arr = fields.filter(v=>this.company[v])
      return arr
    },
  },
  methods: {},
}
</script>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
